import { Injectable } from '@angular/core';
import { ChartDataInterface, ChartTheme } from '@app/shared/components/charts/interfaces/chart.interface';
import { Color } from '@amcharts/amcharts4/.internal/core/utils/Color';
import * as am4core from '@amcharts/amcharts4/core';

@Injectable()
export class ChartHelper {

  public prepareChartData(data: ChartDataInterface[], series: string[]): Array<{ [key: string]: string | number }> {
    return data.map(element => {
      const result = { seriesName: element.item };
      series.forEach((seriesName, index) => {
        result[seriesName] = element.values[index];
      });
      return result;
    });
  }

  public prepareChartDataWithExtendedLabels(
    data: ChartDataInterface[],
    series: string[],
  ): Array<{ [key: string]: string | number }> {
    return data.map(element => {
      const result = { seriesName: element.item };
      series.forEach((seriesName, seriesIndex) => {
        result[`label${seriesIndex}`] = element.labels[seriesIndex];
        result[seriesName] = element.values[seriesIndex];
      });
      return result;
    });
  }

  public getThemeColor(theme: ChartTheme): Color {
    return theme === ChartTheme.WHITE ? am4core.color('#FFFFFF') : am4core.color('#000000');
  }
}
